module.exports = __webpack_public_path__ + "static/prices-7a7dfb35f913cbd668366b4ea795d06e.jpg";